import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  captureStack1fzi4aczwc4hg as captureStack,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var HttpMethod_GET_instance;
var HttpMethod_POST_instance;
var HttpMethod_PUT_instance;
var HttpMethod_PATCH_instance;
var HttpMethod_DELETE_instance;
var HttpMethod_HEAD_instance;
var HttpMethod_entriesInitialized;
function HttpMethod_initEntries() {
  if (HttpMethod_entriesInitialized)
    return Unit_instance;
  HttpMethod_entriesInitialized = true;
  HttpMethod_GET_instance = HttpMethod().pcx('GET', 0);
  HttpMethod_POST_instance = HttpMethod().pcx('POST', 1);
  HttpMethod_PUT_instance = HttpMethod().pcx('PUT', 2);
  HttpMethod_PATCH_instance = HttpMethod().pcx('PATCH', 3);
  HttpMethod_DELETE_instance = HttpMethod().pcx('DELETE', 4);
  HttpMethod_HEAD_instance = HttpMethod().pcx('HEAD', 5);
}
var HttpMethodClass;
function HttpMethod() {
  if (HttpMethodClass === VOID) {
    class $ extends Enum() {
      static pcx(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'HttpMethod');
    HttpMethodClass = $;
  }
  return HttpMethodClass;
}
var ConnectionExceptionClass;
function ConnectionException() {
  if (ConnectionExceptionClass === VOID) {
    class $ extends Exception() {
      static mcx(message, cause) {
        cause = cause === VOID ? null : cause;
        var $this = this.vd(message, cause);
        captureStack($this, $this.lcx_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ConnectionException');
    ConnectionExceptionClass = $;
  }
  return ConnectionExceptionClass;
}
var RequestBodyTextClass;
function RequestBodyText() {
  if (RequestBodyTextClass === VOID) {
    class $ {
      constructor(content, type) {
        this.qcx_1 = content;
        this.rcx_1 = type;
      }
      toString() {
        return 'RequestBodyText(content=' + this.qcx_1 + ', type=' + this.rcx_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.qcx_1);
        result = imul(result, 31) + getStringHashCode(this.rcx_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RequestBodyText()))
          return false;
        if (!(this.qcx_1 === other.qcx_1))
          return false;
        if (!(this.rcx_1 === other.rcx_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RequestBodyText');
    RequestBodyTextClass = $;
  }
  return RequestBodyTextClass;
}
var RequestBodyFileClass;
function RequestBodyFile() {
  if (RequestBodyFileClass === VOID) {
    class $ {
      constructor(content) {
        this.scx_1 = content;
      }
      toString() {
        return 'RequestBodyFile(content=' + toString(this.scx_1) + ')';
      }
      hashCode() {
        return hashCode(this.scx_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RequestBodyFile()))
          return false;
        if (!equals(this.scx_1, other.scx_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RequestBodyFile');
    RequestBodyFileClass = $;
  }
  return RequestBodyFileClass;
}
var RequestBodyBlobClass;
function RequestBodyBlob() {
  if (RequestBodyBlobClass === VOID) {
    class $ {}
    initMetadataForClass($, 'RequestBodyBlob');
    RequestBodyBlobClass = $;
  }
  return RequestBodyBlobClass;
}
function HttpMethod_GET_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_GET_instance;
}
function HttpMethod_POST_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_POST_instance;
}
function HttpMethod_PUT_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_PUT_instance;
}
function HttpMethod_PATCH_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_PATCH_instance;
}
function HttpMethod_DELETE_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_DELETE_instance;
}
//region block: exports
export {
  ConnectionException as ConnectionException1wjs7wwnknnfm,
  RequestBodyBlob as RequestBodyBlob1w7e8wxebrdro,
  RequestBodyFile as RequestBodyFile26cfvm0aih79m,
  RequestBodyText as RequestBodyTextpvofjwd95b3y,
  HttpMethod_DELETE_getInstance as HttpMethod_DELETE_getInstance1ayy9xx1uf6c9,
  HttpMethod_GET_getInstance as HttpMethod_GET_getInstance2m1rvu4d8a2j3,
  HttpMethod_PATCH_getInstance as HttpMethod_PATCH_getInstance2444xhczsg6ri,
  HttpMethod_POST_getInstance as HttpMethod_POST_getInstance3c6ouf174z7cx,
  HttpMethod_PUT_getInstance as HttpMethod_PUT_getInstance1ik48aaxkshw8,
};
//endregion

//# sourceMappingURL=fetch.mjs.map
